<template>
  <div class="buttons" :class="{ 'is-pulled-right': pullRight }">
    <button
      v-for="(btn, index) in navigating"
      :key="index"
      type="button"
      class="options button has-text-info"
      :title="btn.title"
      @click="navigate(btn.route)">
      <i :class="btn.icon"></i>
    </button>

    <button
      v-for="(btn, index) in custom"
      :key="index"
      :class="btn.style"
      :title="btn.title"
      :disabled="btn.disabled === true"
      @click="btn.click.params ? btn.click.fnc(btn.click.params) : btn.click.fnc(id)"
      type="button"
      class="options button">
      <i :class="btn.icon"></i>
    </button>

    <button
      v-if="saving"
      type="button"
      class="options button is-info"
      title="Opslaan"
      :disabled="savingDisabled"
      @click="save()">
      <i class="fas fa-save"></i>
    </button>

    <button
      v-if="saving"
      type="button"
      class="options button has-text-danger"
      title="Annuleren"
      @click="cancel()">
      <i class="fas fa-ban"></i>
    </button>

    <button
      v-if="editing"
      type="button"
      class="options button has-text-info"
      title="Bewerken"
      @click="edit()">
      <i class="fas fa-pen"></i>
    </button>

    <button
      v-if="deleting"
      type="button"
      class="options button has-text-danger"
      :title="deleteTitle"
      @click="toggle()">
      <i class="fas fa-times"></i>
    </button>

    <div class="modal" :class="{ 'is-active': isActive }">
      <div class="modal-background"></div>

      <div class="modal-content">
        <article class="message is-danger">
          <div class="message-header">
            <p>Let op!</p>
          </div>
          <div class="message-body">
            <div class="columns">
              <div class="column">
                <p>Weet je zeker dat je dit item wilt verwijderen? Dit kan niet teruggedraaid worden.</p>
              </div>
            </div>

            <div class="columns">
              <div class="column">
                <div class="buttons">
                  <button type="button" class="button is-danger" @click="confirm()">Ja, verwijderen</button>
                  <button type="button" class="button" @click="toggle()">Nee, annuleren</button>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: null
    },
    custom: {
      type: Array,
      default: null
    },
    saving: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: null
    },
    savingDisabled: {
      type: Boolean,
      default: false
    },
    editing: {
      type: Boolean,
      default: true
    },
    deleting: {
      type: Boolean,
      default: true
    },
    deleteTitle: {
      type: String,
      default: 'Verwijderen'
    },
    navigating: {
      type: Array,
      default: null
    },
    pullRight: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isActive: false
    }
  },
  methods: {
    save () {
      this.$emit('save')
    },
    edit () {
      this.$emit('edit')
    },
    toggle () {
      this.isActive = !this.isActive
    },
    confirm () {
      this.$emit('delete')
      this.toggle()
    },
    cancel () {
      this.$emit('cancel')
    },
    navigate (route) {
      const params = {}

      params[route.params.name] = route.params.value

      this.$router.push({
        name: route.name,
        params
      })
    }
  }
}
</script>

<style scoped>
  .options {
    width: 2rem;
    height: 2rem;
  }
</style>
